/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9 17V11M9 11V6.72437C9 6.04545 9 5.70599 9.11953 5.42478C9.22497 5.17671 9.39532 4.96163 9.61265 4.80217C9.85901 4.62141 10.1894 4.54366 10.8503 4.38816L18.0503 2.69405C19.0574 2.45708 19.561 2.33859 19.9568 2.46516C20.3039 2.57612 20.5986 2.80959 20.7861 3.12197C21 3.47831 21 3.99562 21 5.03025V6.12614C21 6.79614 21 7.13114 20.8829 7.40985C20.7796 7.65575 20.6126 7.86966 20.3991 8.02953C20.1571 8.21073 19.8321 8.29198 19.1821 8.45448L9 11Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9 19C9 20.6569 7.65685 22 6 22C4.34315 22 3 20.6569 3 19C3 17.3431 4.34315 16 6 16C7.65685 16 9 17.3431 9 19ZM9 19V14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<g opacity="0.12">
				<path
					d="M9 18.9999C9 20.6567 7.65685 21.9999 6 21.9999C4.34315 21.9999 3 20.6567 3 18.9999C3 17.343 4.34315 15.9999 6 15.9999C7.65685 15.9999 9 17.343 9 18.9999Z"
					fill="currentColor"
				/>
				<path
					d="M9 6.72424C9 6.04533 9 5.70587 9.11953 5.42466C9.22497 5.17659 9.39532 4.96151 9.61265 4.80205C9.85901 4.62129 10.1894 4.54354 10.8503 4.38804L18.0503 2.69392C19.0574 2.45695 19.561 2.33847 19.9568 2.46504C20.3039 2.576 20.5986 2.80947 20.7861 3.12185C21 3.47819 21 3.9955 21 5.03013V6.12601C21 6.79602 21 7.13102 20.8829 7.40972C20.7796 7.65563 20.6126 7.86954 20.3991 8.02941C20.1571 8.21061 19.8321 8.29186 19.1821 8.45436L9 10.9999V6.72424Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M9 19V11M9 19C9 20.6569 7.65685 22 6 22C4.34315 22 3 20.6569 3 19C3 17.3431 4.34315 16 6 16C7.65685 16 9 17.3431 9 19ZM9 11V6.72437C9 6.04545 9 5.70599 9.11953 5.42478C9.22497 5.17671 9.39532 4.96163 9.61265 4.80217C9.85901 4.62141 10.1894 4.54366 10.8503 4.38816L18.0503 2.69405C19.0574 2.45708 19.561 2.33859 19.9568 2.46516C20.3039 2.57612 20.5986 2.80959 20.7861 3.12197C21 3.47831 21 3.99562 21 5.03025V6.12614C21 6.79614 21 7.13114 20.8829 7.40985C20.7796 7.65575 20.6126 7.86966 20.3991 8.02953C20.1571 8.21073 19.8321 8.29198 19.1821 8.45448L9 11Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.364 9.1821L9.75 11.5856V19C9.75 21.0711 8.07107 22.75 6 22.75C3.92893 22.75 2.25 21.0711 2.25 19C2.25 16.9289 3.92893 15.25 6 15.25C6.8442 15.25 7.62325 15.529 8.25 15.9997V11V6.72438L8.25 6.69955V6.69953C8.24999 6.38128 8.24998 6.10331 8.26693 5.8709C8.285 5.62302 8.32482 5.3772 8.42929 5.13141C8.58746 4.7593 8.84298 4.43668 9.16897 4.19749C9.3843 4.0395 9.61447 3.94444 9.85161 3.87007C10.074 3.80034 10.3446 3.73668 10.6544 3.6638L10.6785 3.65811L17.8785 1.964L17.9103 1.95651C18.3868 1.8444 18.7916 1.74913 19.1258 1.70096C19.4733 1.65088 19.8296 1.63708 20.1853 1.75081C20.7058 1.91725 21.148 2.26745 21.4292 2.73602C21.6214 3.05619 21.6895 3.40618 21.7204 3.75589C21.75 4.09227 21.75 4.50812 21.75 4.99753V5.03026V6.12615L21.7501 6.24402C21.751 6.79509 21.7518 7.27811 21.5744 7.70036C21.4194 8.06922 21.1689 8.39009 20.8486 8.6299C20.482 8.90442 20.0132 9.02083 19.4784 9.15363L19.364 9.1821Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M12 10.25L19.1821 8.45448C19.8321 8.29198 20.1571 8.21073 20.3991 8.02953C20.6126 7.86966 20.7796 7.65575 20.8829 7.40985C21 7.13114 21 6.79614 21 6.12614V5.03025C21 3.99562 21 3.47831 20.7861 3.12197C20.5986 2.80959 20.3039 2.57612 19.9568 2.46516C19.561 2.33859 19.0574 2.45708 18.0503 2.69405L10.8503 4.38816C10.1894 4.54366 9.85901 4.62141 9.61265 4.80217C9.39532 4.96163 9.22497 5.17671 9.11953 5.42478C9 5.70599 9 6.04545 9 6.72437V11V19C9 20.6569 7.65685 22 6 22C4.34315 22 3 20.6569 3 19C3 17.3431 4.34315 16 6 16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M9 19V11M9 19C9 20.6569 7.65685 22 6 22C4.34315 22 3 20.6569 3 19C3 17.3431 4.34315 16 6 16C7.65685 16 9 17.3431 9 19ZM9 11V6.72437C9 6.04545 9 5.70599 9.11953 5.42478C9.22497 5.17671 9.39532 4.96163 9.61265 4.80217C9.85901 4.62141 10.1894 4.54366 10.8503 4.38816L18.0503 2.69405C19.0574 2.45708 19.561 2.33859 19.9568 2.46516C20.3039 2.57612 20.5986 2.80959 20.7861 3.12197C21 3.47831 21 3.99562 21 5.03025V6.12614C21 6.79614 21 7.13114 20.8829 7.40985C20.7796 7.65575 20.6126 7.86966 20.3991 8.02953C20.1571 8.21073 19.8321 8.29198 19.1821 8.45448L9 11Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.364 9.18198L9.75 11.5855V18.9999C9.75 19.4141 9.41422 19.7499 9 19.7499C8.58579 19.7499 8.25 19.4141 8.25 18.9999V10.9999V6.72426V6.69943V6.6994C8.24999 6.38115 8.24998 6.10319 8.26693 5.87078C8.28501 5.6229 8.32482 5.37708 8.42929 5.13129C8.58746 4.75918 8.84298 4.43656 9.16897 4.19737C9.3843 4.03938 9.61447 3.94432 9.85161 3.86995C10.074 3.80022 10.3446 3.73656 10.6544 3.66368L10.6544 3.66368L10.6785 3.65799L17.8785 1.96387L17.9103 1.95639C18.3868 1.84428 18.7916 1.74901 19.1258 1.70084C19.4733 1.65076 19.8296 1.63696 20.1853 1.75069C20.7058 1.91712 21.148 2.26732 21.4292 2.7359C21.6214 3.05606 21.6895 3.40605 21.7204 3.75577C21.75 4.09215 21.75 4.50802 21.75 4.99745V5.03014V6.12603L21.7501 6.24389C21.751 6.79497 21.7518 7.27798 21.5744 7.70024C21.4194 8.0691 21.1689 8.38997 20.8486 8.62977C20.482 8.9043 20.0132 9.0207 19.4784 9.15351L19.364 9.18198Z"
				fill="currentColor"
			/>
			<path
				d="M6 15.25C3.92893 15.25 2.25 16.9289 2.25 19C2.25 21.0711 3.92893 22.75 6 22.75C8.07107 22.75 9.75 21.0711 9.75 19C9.75 16.9289 8.07107 15.25 6 15.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
